import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import OrderSubtotal from '../OrderItems/common/OrderSubtotal/OrderSubtotal';
import ProceedToCheckoutButton from '../OrderItems/common/ProceedToCheckoutButton/ProceedToCheckoutButton';
import EmailToCartButton from '../OrderItems/common/EmailToCartButton/EmailToCartButton';
import styles from './OrderSummary.module.scss';
import { getCartItemsCount } from '../../utils';
import { STATUS, GENERIC_USER_ID } from '@app/constants/commonConstants';
import { InlineLoader } from 'cat-ecommerce-alloy';

const OrderSummary = () => {
  const [t] = useTranslation();
  const { emailCart, userId } = useSelector(s => s.common);
  const { checkoutType, getCurrentOrderStatus } = useSelector(s => s.orders);
  const ascendingOrderItems = useSelector(
    s => s.orders.byId[s.orders.current]?.ascendingOrderItems || []
  );
  const isGenericUser = userId === GENERIC_USER_ID;
  const getCurrentOrderLoading =
    (!isGenericUser && getCurrentOrderStatus === STATUS.IDLE) ||
    getCurrentOrderStatus === STATUS.PENDING;

  const getCartButton = () => {
    return emailCart || checkoutType === 'emailCart' ? (
      <EmailToCartButton className="d-print-none w-100" />
    ) : (
      <ProceedToCheckoutButton className="d-print-none w-100" />
    );
  };
  const itemCount = getCartItemsCount(ascendingOrderItems);
  const itemCountDescriptor =
    itemCount === '1' ? t('2691_ITEM') : t('MO_ITEMS');

  const getItemCount =
    getCurrentOrderLoading && !ascendingOrderItems.length ? (
      <InlineLoader />
    ) : (
      <b className="u-fs--14 u-color--DarkGray text-univers--bold fw-normal d-print-inline-flex">
        {itemCount}
        <span className="d-none d-print-inline-block ps-1 my-0 text-sans-serif u-color--Black text-capitalize">
          {itemCountDescriptor}
        </span>
      </b>
    );

  return ascendingOrderItems.length || getCurrentOrderLoading ? (
    <div className={`${styles['floating-cart-container']}`}>
      <h2 className="h3 u-fs-md--20 mb-0 u-color--ExtraDarkGray">
        {t('TITLE_ORDER_SUMMARY')}
      </h2>
      <div className="d-flex my-2 py-1">
        <b className="flex-grow-1 text-start u-fs--14 u-color--DarkGray text-univers--bold text-uppercase fw-normal">
          {t('MO_ORD_TOTAL_ITEMS')}
        </b>
        {getItemCount}
      </div>

      {emailCart ? null : <OrderSubtotal isFromOrderSummary />}

      {getCartButton()}
    </div>
  ) : null;
};

export default OrderSummary;
